const ErrorService = {
    getMessage: (e: any) => {
        return e.Stack || e.stack || e.toString()
    }
};

export default ErrorService;